import React from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import DebriefThemeProvider from 'ff/debrief/components/DebriefThemeProvider';
import ToastBar from 'ff/debrief/components/ToastBar';
import SharePageRoute from 'ff/debrief/router/routes/SharePageRoute';

const router = createBrowserRouter([SharePageRoute], { basename: '/shared' });

const ShareApp = () => {
    return (
        <DebriefThemeProvider>
            <RouterProvider router={router} />
            <ToastBar />
        </DebriefThemeProvider>
    );
};

export default ShareApp;
